import { FC } from 'react';

const BackIcon: FC<{ size?: number }> = ({ size = 40 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 40 41"
    fill="none"
  >
    <circle
      cx="20"
      cy="20"
      r="19.5"
      transform="matrix(-1 0 0 1 40 0.5)"
      stroke="#1D1D1D"
    />
    <path
      d="M27 20.3444L13 20.3444M13 20.3444L19.72 27.5M13 20.3444L19.72 13.5"
      stroke="#1D1D1D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BackIcon;
